import React from "react";
import { BillingFields, fieldClass } from "./billing";

interface Props {
  value: BillingFields;
  onChange: (next: BillingFields) => void;
}

// BillingForm collects the invoice snapshot. VAT ID stays optional.
const BillingForm: React.FC<Props> = ({ value, onChange }) => {
  const set = (key: keyof BillingFields) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange({ ...value, [key]: event.target.value });
  };

  return (
    <div className="space-y-4">
      <Field label="Salutation" id="salutation" value={value.salutation} onChange={set("salutation")} required />
      <Field label="Company" id="company" value={value.company} onChange={set("company")} required />
      <Field label="Street" id="street" value={value.street} onChange={set("street")} required />
      <Field label="Postal code" id="postal_code" value={value.postal_code} onChange={set("postal_code")} required />
      <Field label="City" id="city" value={value.city} onChange={set("city")} required />
      <Field label="Country" id="country" value={value.country} onChange={set("country")} required />
      <Field label="Billing email" id="billing_email" type="email" value={value.billing_email} onChange={set("billing_email")} required />
      <Field label="VAT ID (optional)" id="vat_id" value={value.vat_id} onChange={set("vat_id")} />
      <Field label="Number of projects" id="project_count" type="number" value={value.project_count} onChange={set("project_count")} required />
      <div>
        <label htmlFor="message" className="block text-sm font-medium leading-5 text-gray-700">
          Message (optional)
        </label>
        <textarea
          id="message"
          value={value.message}
          onChange={set("message")}
          className={`${fieldClass} mt-1`}
          rows={3}
        />
      </div>
    </div>
  );
};

const Field: React.FC<{
  label: string;
  id: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  required?: boolean;
}> = ({ label, id, value, onChange, type, required }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium leading-5 text-gray-700">
      {label}
    </label>
    <input
      id={id}
      type={type || "text"}
      required={required}
      min={type === "number" ? 1 : undefined}
      value={value}
      onChange={onChange}
      className={`${fieldClass} mt-1`}
    />
  </div>
);

export default BillingForm;
